import React from 'react';
import IconWrapper from '../../../IconWrapper';
const AccountDefaultIconMedium = (props) => (React.createElement(IconWrapper, { ...props },
    React.createElement("path", { d: "M8 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm7.603 4.799a6 6 0 1 0-7.204.001C5.199 14.295 3 17.719 3 21.622v1h2v-1C5 17.341 8.211 14 12 14c3.797 0 7 3.34 7 7.622v1h2v-1c0-3.904-2.195-7.329-5.397-8.823Z" })));
export default AccountDefaultIconMedium;
//# sourceMappingURL=AccountDefaultIconMedium.js.map